module.exports = __webpack_public_path__ + "img/veteconomicsLogo.c672812e.png";